<template>
    <!-- 和分享-客户列表使用的一套接口 -->
    <div class="item-box">
        <el-dialog
            :visible.sync="addialogVisible"
            :close-on-click-modal="false"
            width="80%"
            title="打开明细"
            :before-close="close"
            append-to-body
        >
            <div class="infor-item">
                <sc-table-v2
                    v-if="addialogVisible"
                    :head="tableHead"
                    :data="list"
                    :page="page"
                    :page-hide="false"
                    :read-table="true"
                    :load="load"
                    :pop-show="false"
                    :show-add="false"
                    :table-height="tableHeightCalc"
                    :selection="false"
                    ref="refTable"
                    @pageChange="pageChange"
                    @pageSizesChange="pageSizesChange"
                ></sc-table-v2>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getShareInfoList, getShareReadingList, getDossierList } from '@/api/mkt/user.js';
import getListMixin from '@/mixins/getListMixin';
import mixins from '@/mixins';

export default {
    name: 'browse-list',
    mixins: [getListMixin, mixins],
    props: {
        title: {
            type: String,
            default: '',
        },
    },
    watch: {},
    data() {
        return {
            load: false,
            addialogVisible: false,
            tableHead: [
                { name: '昵称', key: 'nickName', width: 150 },
                { name: '手机号', key: 'mobileLastFour', width: 150 },
                { name: '身份', key: 'identification', width: 150 },
                // { name: '角色', key: 'customerStatus', width: 150 },
                { name: '打开时间', key: 'createTime' },
            ],
            tableHeightCalc: window.innerHeight - 420,
            page: {
                size: 30,
                page: 1,
                count: 0,
            },
            list: [],
            type: '',
            row: {},
            optionsData: {},
        };
    },
    methods: {
        async getShareReadingListFn() {
            this.load = true;
            let res = await getShareReadingList({
                sharingRecordsId: this.row.id,
                page: this.page.page,
                size: this.page.size,
            });
            if (res.code == 200) {
                this.load = false;
                for (let item of res?.data?.children) {
                    const roleData = this.optionsData['identity'].find(
                        val => val.dictValue == item.identity
                    );
                    item.identity = roleData?.sysLabel;
                    item.customerStatus = roleData?.children?.find(
                        val => val.dictValue == item.customerStatus
                    )?.sysLabel;
                }
                this.list = res.data.children;
                this.page.count = res.data.total;
            }
        },
        async getDossierListData() {
            let res = await getDossierList({});
            console.log(res);
            if (res.isSuccess) {
                const map = {
                    identity: 'identification', // 身份角色
                    tool: 'toolsVo', // 工具测试
                    appointment: 'reservationVo', // 预约咨询
                    device: 'terminalVo', // 对应列表terminal
                    terminal: 'terminalVo',
                    timeFrame: 'timeVo', // 已废弃 改为选择时间范围
                };
                let obj = {};
                for (let key in map) {
                    const value = map[key];
                    obj[key] = res.data[value];
                }
                this.optionsData = obj;
            }
        },
        async open(row) {
            this.page.page = 1;
            this.row = row || {};
            await this.getDossierListData();
            await this.getShareReadingListFn();
            this.addialogVisible = true;
        },
        close() {
            this.addialogVisible = false;
        },
        goAcquCustomer(row) {
            this.$router.push({
                path: '/mkt/acquisition/acqu-customer',
                query: {
                    sharingRecordsId: row.id,
                },
            });
        },
        isOpenFormatter(row) {
            let obj = { 1: '是', 0: '否' };
            return obj[row.isOpen] || '';
        },
        pageChange(val) {
            this.page.page = val;
            this.getShareReadingListFn();
            this.$nextTick(() => {
                this.$refs.refTable.$refs['table-box'].bodyWrapper.scrollTop = 0;
            });
        },
        pageSizesChange(val) {
            this.page.size = val;
            this.getShareReadingListFn();
        },
    },
};
</script>

<style lang="less" scoped>
.item-box {
    margin-bottom: 20px;
    /deep/ .el-dialog__body {
        padding: 10px 20px !important;
    }
    .top-line {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d7d7d7;
        line-height: 34px;
        .tit {
            color: #d9001b;
        }
    }
    .item-box-link {
        cursor: pointer;
        color: #006eff;
    }
    .item-box-user {
        display: flex;
        text-align: center;
        justify-content: flex-start;
        .item-box-user-item + .item-box-user-item {
            margin-left: 8px;
        }
        .image {
            width: 50px;
            height: 50px;
        }
        .text {
            text-wrap: nowrap;
        }
    }
}
</style>
